export default __webpack_public_path__ + "static/media/gb_sample_0.aa8f39e4.jpg";